import { render, staticRenderFns } from "./qn-foryuma2024Confirm.vue?vue&type=template&id=224c45d9&"
import script from "./qn-foryuma2024Confirm.vue?vue&type=script&lang=js&"
export * from "./qn-foryuma2024Confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports